<style>


.Secondary_Action {
    height: 240px;
}

.new_screen {
    width: 100px;
    padding: 0;
}

a.manage_spots {
    padding: 1.2rem;
    margin-right: 3rem;
}

.Secondary_Action {
    background-color: #ddebe9;
}

h4 {
    color: rgb(71, 71, 71)!important;
}

.NewScreen_Class {
  cursor: pointer;
  background: #8DE5D0;
}

</style>
<script>
    import { Col, Container, Row } from "sveltestrap";
    import {BSGet} from '../js-core/conn/reqs'
    import { writable } from "svelte/store";
    export let TV = {}
    export let params
    const getScreensProm = getScreens()
    async function getScreens() {
        const ret = await BSGet('tv-owner/b-sticks')
        const body = (await ret.json()).response
        // Weird bug fix
        if (body.length === 1 && body[0] === null) body = []
        // TODO implement stores in a smart way
        localStorage.setItem("screensInfo", JSON.stringify(body));
        return body
    }
    function changeToNewSpot() {
        let groupNumber = params.group
        window.location = `#/brite-host/${groupNumber}/manage-screens`
    }

    function navigateToManageScreen(screenId) {
        let groupNumber = params.group
        window.location = `#/brite-host/${groupNumber}/manage-screen/${screenId}`
    }
    function changeToNewScreen() {
        window.location = `#/brite-host/setup-britestick`
    }
</script>
{#await getScreensProm}
    Loading your screen data...
{:then screens}
<Container>
    <Row class="justify-conent-end">
        <a class = "manage_spots" href="/#/brite-host/{params.group}/manage-spots" style="">
            <button class="main action">
                Manage Spots
            </button>
        </a>
    </Row>
</Container>
<Container>
    <Row class="justify-content-center">
        {#if screens.length === 0}
            <Col xs="12">
                <Row class="justify-content-center">
                    <Col xs="8" sm="4">
                        <p>Look's like you have no Brite Screens setup. Please setup one up by clicking
                        <a href="#" on:click|preventDefault={changeToNewScreen}> here.</a></p>
                    </Col>
                </Row>
            </Col>
        {/if}
        {#each screens as screen, i}
        <Col sm="6" md="4" class="justify-content-center">
            <div class="Secondary_Action">
                <img src="static/icons/TVScreen.png" alt="TV Screen" style="height: 50%;"/>
                <p class="Description_Text">{screen.description || "Click \"Manage Screen\" and add a description"}</p>
                <button class="normal" on:click={() => navigateToManageScreen(i)}>Manage Screen</button>
            </div>
        </Col>
        {/each}
    </Row>
</Container>
{:catch error}
    <!-- getScreensProm was rejected -->
{/await}